import { render } from "./SystemAdmin12.vue?vue&type=template&id=3f5c11e8"
import script from "./SystemAdmin12.vue?vue&type=script&lang=js"
export * from "./SystemAdmin12.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__